import Screen from "./components/Screen"
import Button from "./components/Button"
import { spacing } from "./styles"

import "./AaoLens.scss"
import Flex from "../../components/Flex"
import Icons from "../../components/Icons"
import datasource from "../../datasource"

interface Step {
    title: string
    text: string
}

interface Capability {
    title: string
    description: string
}

const {
    pageTitle,
    pageSubTitle,
    heroCtaLabel,
    heroCtaLink,
    pitch,
    highlight,
    flow,
    capabilities,
    welcomeTitle,
    welcomeSubTitle,
    welcomeBtnLabel
} = datasource.aaoLens

export default () => {

    // the app lives on its own domain, so this leaves the site rather than routing
    const goToApp = () => {
        window.open(heroCtaLink, "_blank", "noopener,noreferrer")
    }

    return (
        <div className="aaolens">
            <Screen className="aaolens__title-screen">
                <Flex vertical align="center" gap={spacing("4xl")}>
                    <Flex align="center" justify="center" className="aaolens__hero-icon">
                        <Icons.AaoLens width={74} height={74}></Icons.AaoLens>
                    </Flex>
                    <div className="aaolens__title">{pageTitle}</div>
                    <div className="aaolens__subTitle">{pageSubTitle}</div>
                    <Button onClick={goToApp}>
                        <Flex gap={spacing("md")} reposive={false} align="center">
                            {heroCtaLabel}
                            <Icons.ArrowUp width={16} height={16}></Icons.ArrowUp>
                        </Flex>
                    </Button>
                </Flex>
            </Screen>

            <Screen className="aaolens__pitch-screen">
                <div className="aaolens__panel">
                    <Flex vertical gap={spacing("3xl")}>
                        <div className="aaolens__section-title">{pitch.title}</div>
                        {pitch.paragraphs.map((paragraph, i) => (
                            <div key={i} className="aaolens__pitch__text">{paragraph}</div>
                        ))}
                    </Flex>
                </div>
            </Screen>

            <Screen className="aaolens__highlight-screen">
                <div className="aaolens__highlight">
                    <Flex justify="space-between" gap={spacing("6xl")}>
                        <Flex vertical gap={spacing("xl")} className="aaolens__highlight__left">
                            <div className="aaolens__highlight__eyebrow">{highlight.eyebrow}</div>
                            <div className="aaolens__highlight__title">{highlight.title}</div>
                            <div className="aaolens__highlight__description">{highlight.description}</div>
                            <Flex vertical gap={spacing("md")} className="aaolens__highlight__examples">
                                {highlight.examples.map(example => (
                                    <div key={example} className="aaolens__highlight__example">&ldquo;{example}&rdquo;</div>
                                ))}
                            </Flex>
                        </Flex>
                        <Flex vertical gap={spacing("xl")} justify="center" className="aaolens__highlight__right">
                            {highlight.points.map(point => (
                                <div key={point} className="aaolens__highlight__point">{point}</div>
                            ))}
                        </Flex>
                    </Flex>
                </div>
            </Screen>

            <Screen className="aaolens__flow-screen">
                <Flex vertical gap={spacing("6xl")}>
                    <Flex vertical align="center" gap={spacing("xl")} className="aaolens__section-head">
                        <div className="aaolens__section-title">{flow.title}</div>
                        <div className="aaolens__section-subTitle">{flow.subTitle}</div>
                    </Flex>
                    {/* plain div, not Flex: Flex writes an inline display:flex that would beat display:grid */}
                    <div className="aaolens__flow__steps">
                        {(flow.steps as Step[]).map((step, idx) => <StepCard key={step.title} step={step} index={idx}></StepCard>)}
                    </div>
                </Flex>
            </Screen>

            <Screen className="aaolens__capabilities-screen">
                <Flex vertical align="center" gap={spacing("xl")} className="aaolens__section-head">
                    <div className="aaolens__section-title">{capabilities.title}</div>
                    <div className="aaolens__section-subTitle">{capabilities.subTitle}</div>
                </Flex>
                <div className="aaolens__capabilities">
                    {(capabilities.items as Capability[]).map(capability => (
                        <Flex vertical gap={spacing("md")} key={capability.title} className="capability-card">
                            <div className="capability-card__title">{capability.title}</div>
                            <div className="capability-card__description">{capability.description}</div>
                        </Flex>
                    ))}
                </div>
            </Screen>

            <div className="aaolens__welcome-box">
                <Flex className="aaolens__welcome" justify="space-between">
                    <Flex vertical gap={10}>
                        <div className="aaolens__welcome__title">{welcomeTitle}</div>
                        <div className="aaolens__welcome__subTitle">{welcomeSubTitle}</div>
                    </Flex>
                    <Flex vertical justify="flex-end">
                        <Button onClick={goToApp}>
                            <Flex gap={spacing("md")} reposive={false} align="center">
                                {welcomeBtnLabel}
                                <Icons.ArrowUp width={16} height={16}></Icons.ArrowUp>
                            </Flex>
                        </Button>
                    </Flex>
                </Flex>
            </div>
        </div>
    )
}

const StepCard = (props: { step: Step, index: number }) => {
    return (
        <div className="step-card">
            <div className="step-card__badge">{props.index + 1}</div>
            <div className="step-card__title">{props.step.title}</div>
            <div className="step-card__text">{props.step.text}</div>
        </div>
    )
}
